<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.details }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.blog.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Naziv</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="blog.title"
                      />
                      <form-error
                        :model="$v.blog.title"
                        :dirty="$v.$dirty"
                        label="Naziv"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Slug
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Slug"
                        readonly
                        :value="blog.title | slugify"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.blog.shortDescription.$anyError,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Kratak opis</label
                    >
                    <div class="col-lg-7 col-xl-9">
                      <tinymce
                        apiKey="c2228qw6yoc6plpirkd45g0ufvnlq6fhmszzajrm6if2rbv4"
                        name="html-editor-2"
                        :init="{
                          ...appSettings.tinyMceConfig,
                        }"
                        v-model="blog.shortDescription"
                        id="short-description"
                      ></tinymce>
                      <form-error
                        :model="$v.blog.shortDescription"
                        :dirty="$v.$dirty"
                        label="Kratak opis"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.blog.description.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Opis</label
                    >
                    <div class="col-lg-7 col-xl-9">
                      <tinymce
                        apiKey="c2228qw6yoc6plpirkd45g0ufvnlq6fhmszzajrm6if2rbv4"
                        name="html-editor"
                        :init="{
                          ...appSettings.tinyMceConfig,
                        }"
                        v-model="blog.description"
                        id="description"
                      ></tinymce>

                      <form-error
                        :model="$v.blog.description"
                        :dirty="$v.$dirty"
                        label="Opis"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Dostupno na</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="blog.blogContentType"
                      >
                        <option
                          v-for="item in blogContentTypes"
                          :value="item.id"
                          :key="item.id"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Vidljivo na webu?</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox">
                        <label class="my-2">
                          <input
                            type="checkbox"
                            id="visible-on-web"
                            v-model="blog.isVisibleOnWeb"
                          />
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Vidljivo od</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <datepicker
                        placeholder="Početak"
                        v-model="blog.visibleFrom"
                        input-class="form-control form-control-modern bg-body"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      for="display-author-name"
                    >
                      Prikazati ime autora?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox">
                        <label class="my-2">
                          <input
                            type="checkbox"
                            id="display-author-name"
                            v-model="blog.displayAuthorName"
                          />
                        </label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    v-if="blog.imageUrl"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <div class="popup-gallery row">
                        <div class="img-fluid">
                          <img
                            class="img-thumbnail"
                            :src="`${baseUrl}${blog.imageUrl}`"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Glavna slika</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photo"
                        @change="handlePhotoUpload"
                        accept="image/*"
                      />
                      <span class="form-text">
                        Učitajte sliku rezolucije 1050px x 350px
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-tag"></i>
                  <h2 class="card-big-info-title">{{ translations.metaSeoDetails }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.metaSeo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naslov</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="blog.metaSeo.title"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Opis</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Opis"
                        v-model="blog.metaSeo.description"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Keyword</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Keyword"
                        v-model="blog.metaSeo.keyword"
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            exact
            :to="{ name: 'Blogs' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>

          <button
            type="button"
            @click="copyBlog()"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-copy text-4 me-2"></i>
            {{ translations.copyBlog }}
          </button>

          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteBlog }}</strong>
        </h5>
        <div slot="body">
          <span v-html="modalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteBlog"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import tinymce from '@tinymce/tinymce-vue';

import Datepicker from 'vuejs-datepicker';
import bs from 'vuejs-datepicker/dist/locale/translations/bs';

import { format } from 'date-fns';

import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import config from '@/config';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';

export default {
  name: 'EditBlog',
  mixins: [translations],
  validations: {
    blog: { ...validations },
  },
  data() {
    return {
      blogContentTypes: [
        {
          id: 1,
          text: 'B2B',
        },
        {
          id: 2,
          text: 'B2C',
        },
        {
          id: 3,
          text: 'Sve',
        },
      ],
    };
  },
  components: {
    Datepicker,
    tinymce,
    FormError,
    Modal,
  },
  computed: {
    modalText() {
      return this.translations.areYouSureBlog.replace(
        '{blog}',
        `<strong>${this.blog.title}</strong>`
      );
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
    blog() {
      // Temporary solution unitl API is updated
      const selectedBlog = this.$store.getters.getBlog;
      return {
        ...selectedBlog,
        metaSeo: {
          title: null,
          description: null,
          keyword: null,
        }
      }
      // return this.$store.getters.getBlog;
    },
    baseUrl() {
      return config.baseUrl;
    },
    appSettings() {
      return config.appSettings;
    },
    bs() {
      return bs;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return {
        to: date,
      };
    },
  },
  methods: {
    copyBlog() {
      this.$v.$touch();

      this.$store.dispatch('makeCopyOfBlog', this.blog);
      this.$router.push({ name: 'CopyBlog' });
    },
    formatDate(date, dateFormat = 'dd.MM.yyyy, HH:mm') {
      return format(new Date(date), dateFormat);
    },
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const formData = new FormData();
      const { blog } = this;

      formData.append('title', blog.title);
      formData.append('description', blog.description);
      formData.append('shortDescription', blog.shortDescription);
      formData.append('isVisibleOnWeb', blog.isVisibleOnWeb);
      formData.append('id', blog.id);
      formData.append('displayAuthorName', blog.displayAuthorName);
      formData.append('blogContentType', blog.blogContentType);
      // Sačuvaj postojeći redoslijed prikaza (mijenja se preko liste vijesti),
      // kako izmjena vijesti ne bi resetovala redoslijed na 0.
      formData.append('displayOrder', blog.displayOrder || 0);
      formData.append('displayOrderB2C', blog.displayOrderB2C || 0);
      formData.append(
        'visibleFrom',
        `${this.formatDate(blog.visibleFrom, 'yyyy-MM-dd')}T00:00:00.000Z`,
      );

      if (this.$refs.photo.files[0]) {
        formData.append('Image', this.$refs.photo.files[0]);
      }

      api
        .updateBlog(formData)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Blogs' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.posterUrl = e.target.result;
      };
    },
    deleteBlog() {
      api
        .deleteBlogs([this.blog.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Blogs' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: 'Blogs' });
        });
    },
    customFormatter(date) {
      return format(date, 'MM.dd.yyyy');
    },
  },
  mounted() {
    this.$store.dispatch('getBlog', this.$route.params.id);
  },
};
</script>
